// extracted by mini-css-extract-plugin
export default {"selected-client":"search-inactive-clients_selected-client__Ec+8n"};